var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 935.4 285.2",
    style: {
      enableBackground: "new 0 0 935.4 285.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A6A6A6;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#00C1FF;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{fill:url(#SVGID_2_);}\n\t.st5{fill:url(#SVGID_3_);}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{fill:url(#SVGID_5_);}\n\t.st8{fill:url(#SVGID_6_);}\n\t.st9{fill:url(#SVGID_7_);}\n\t.st10{fill:url(#SVGID_8_);}\n\t.st11{fill:url(#SVGID_9_);}\n\t.st12{fill:url(#SVGID_10_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M893.7,278.9H39c-18.8,0-34.2-15.4-34.2-34.2V39.2C4.8,20.4,20.2,5,39,5h854.7c18.8,0,34.2,15.4,34.2,34.2v205.5 C927.9,263.5,912.5,278.9,893.7,278.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M893.7,5H39C20.2,5,4.8,20.4,4.8,39.2v205.5c0,18.8,15.4,34.2,34.2,34.2h854.7c18.8,0,34.2-15.4,34.2-34.2 V39.2C927.9,20.4,912.5,5,893.7,5 M893.7,10.5c15.8,0,28.7,12.9,28.7,28.8v205.5c0,15.9-12.9,28.8-28.7,28.8H39 c-15.8,0-28.7-12.9-28.7-28.8V39.2c0-15.9,12.9-28.8,28.7-28.8L893.7,10.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M329.1,75.2c0,5.7-1.7,10.3-5.1,13.7c-3.9,4.1-8.9,6.1-15.1,6.1c-5.9,0-11-2.1-15.1-6.2 c-4.1-4.1-6.2-9.2-6.2-15.3c0-6.1,2.1-11.2,6.2-15.3c4.1-4.1,9.2-6.2,15.1-6.2c2.9,0,5.8,0.6,8.4,1.7c2.7,1.2,4.8,2.7,6.4,4.6 l-3.6,3.6c-2.7-3.3-6.5-4.9-11.2-4.9c-4.3,0-8.1,1.5-11.2,4.6c-3.2,3-4.7,7-4.7,11.9c0,4.9,1.6,8.8,4.7,11.9 c3.2,3,6.9,4.6,11.2,4.6c4.6,0,8.4-1.5,11.5-4.6c2-2,3.1-4.8,3.4-8.3h-14.9v-4.9h19.9C329,73.1,329.1,74.2,329.1,75.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M329.1,75.2h-0.7c0,5.6-1.6,10-4.9,13.2l0,0l0,0c-3.7,3.9-8.5,5.9-14.6,5.9c-5.8,0-10.6-2-14.6-6 c-4-4-6-8.9-6-14.8c0-5.9,2-10.8,6-14.8c4-4,8.9-6,14.6-6c2.9,0,5.6,0.6,8.2,1.7c2.6,1.1,4.6,2.6,6.2,4.4l0.5-0.4l-0.5-0.5 l-3.6,3.6l0.5,0.5l0.5-0.4c-2.8-3.4-6.8-5.1-11.8-5.1c-4.5,0-8.4,1.6-11.7,4.8c-3.3,3.2-4.9,7.3-4.9,12.3c0,5,1.6,9.2,4.9,12.3 c3.3,3.2,7.2,4.8,11.7,4.8c4.7,0,8.8-1.6,11.9-4.8c2.1-2.1,3.3-5.1,3.6-8.7l0.1-0.7h-15v-3.6h19.2v-0.7l-0.7,0.1c0.2,1,0.3,2,0.3,3 h1.4c0-1-0.1-2.1-0.3-3.2l-0.1-0.6h-21.1v6.3h15.6V77l-0.7-0.1c-0.3,3.4-1.4,6-3.2,7.9c-2.9,2.9-6.5,4.4-11,4.4 c-4.2,0-7.7-1.4-10.7-4.4c-3-2.9-4.5-6.6-4.5-11.4c0-4.7,1.5-8.4,4.5-11.4c3-2.9,6.6-4.4,10.7-4.4c4.6,0,8.1,1.5,10.7,4.6l0.5,0.6 l4.1-4.1l0.4-0.4l-0.4-0.5c-1.7-2-3.9-3.6-6.7-4.8c-2.8-1.2-5.7-1.8-8.7-1.8c-6.1,0-11.3,2.1-15.6,6.4c-4.3,4.2-6.4,9.5-6.4,15.8 c0,6.2,2.1,11.6,6.4,15.8c4.3,4.2,9.5,6.4,15.6,6.4c6.3,0,11.6-2.1,15.6-6.3l-0.5-0.5l0.5,0.5c3.5-3.5,5.3-8.3,5.3-14.2L329.1,75.2  M360.6,58h-18.7v13h16.8V76h-16.8v13h18.7v5h-24V52.9h24V58"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.6,58v-0.7h-19.4v14.4h16.8v3.6l-16.8,0v14.4h18.7v3.7h-22.6V53.6h22.6V58L360.6,58v-0.7V58l0.7,0v-5.7 h-25.3v42.5h25.3v-6.4h-18.7V76.6h16.8v-6.3h-16.8V58.7h18.7V58L360.6,58 M382.8,94h-5.3V58h-11.5v-5h28.2v5h-11.5V94"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.8,94v-0.7h-4.6v-36h-11.5v-3.7h26.8v3.7h-11.5V94L382.8,94l0-0.7L382.8,94l0.7,0V58.7H395v-6.4h-29.6v6.4 h11.5v36h6.6V94L382.8,94 M414.7,94V52.9h5.3V94L414.7,94"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.7,94h0.7V53.6h3.9v39.7h-4.6V94l0.7,0L414.7,94v0.7h6V52.3H414v42.5h0.7V94 M443.3,94H438V58h-11.5v-5 h28.2v5h-11.5V94"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.3,94v-0.7h-4.6v-36h-11.5v-3.7h26.8v3.7h-11.5V94L443.3,94l0-0.7L443.3,94l0.7,0V58.7h11.5v-6.4h-29.6 v6.4h11.5v36h6.6V94L443.3,94 M482,85.3c3,3.1,6.8,4.6,11.1,4.6s8.1-1.5,11.1-4.6c3-3.1,4.6-7,4.6-11.8c0-4.8-1.5-8.7-4.6-11.8 c-3-3.1-6.7-4.6-11.1-4.6s-8.1,1.5-11.1,4.6c-3,3.1-4.6,7-4.6,11.8C477.4,78.3,478.9,82.2,482,85.3z M508.1,88.7 c-4,4.2-9,6.2-15,6.2c-6,0-11-2.1-15-6.2c-4-4.1-6-9.2-6-15.2s2-11.1,6-15.2c4-4.2,9-6.2,15-6.2c6,0,11,2.1,15,6.3 c4,4.2,6.1,9.2,6.1,15.2C514.2,79.5,512.2,84.6,508.1,88.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M482,85.3l-0.5,0.5c3.1,3.2,7.1,4.8,11.6,4.8c4.6,0,8.5-1.6,11.6-4.8c3.2-3.2,4.8-7.4,4.8-12.3 c0-4.9-1.6-9.1-4.8-12.3c-3.1-3.2-7.1-4.8-11.6-4.8c-4.6,0-8.5,1.6-11.6,4.8c-3.2,3.2-4.8,7.4-4.8,12.3c0,4.9,1.6,9.1,4.8,12.3 L482,85.3l0.5-0.5c-2.9-3-4.4-6.7-4.4-11.3c0-4.6,1.5-8.4,4.4-11.3c2.9-3,6.4-4.4,10.7-4.4c4.2,0,7.7,1.5,10.7,4.4 c2.9,3,4.4,6.7,4.4,11.3c0,4.6-1.5,8.4-4.4,11.3c-2.9,3-6.4,4.4-10.7,4.4c-4.2,0-7.7-1.5-10.7-4.4L482,85.3z M508.1,88.7l-0.5-0.5 c-3.9,4-8.7,6-14.6,6c-5.8,0-10.6-2-14.5-6l0,0l0,0c-3.9-4-5.8-8.9-5.8-14.8c0-5.9,1.9-10.7,5.8-14.8c3.9-4,8.7-6,14.5-6 c5.8,0,10.6,2,14.5,6.1c3.9,4.1,5.9,8.9,5.9,14.7c0,5.9-1.9,10.7-5.8,14.8L508.1,88.7l0.5,0.5c4.1-4.3,6.2-9.6,6.2-15.7 c0-6.1-2.1-11.4-6.3-15.7c-4.2-4.3-9.4-6.5-15.5-6.5c-6.2,0-11.4,2.2-15.5,6.4v0c-4.2,4.3-6.2,9.6-6.2,15.7 c0,6.2,2.1,11.4,6.2,15.7l0,0l0,0c4.1,4.3,9.4,6.4,15.5,6.4c6.2,0,11.4-2.2,15.5-6.4L508.1,88.7z M521.6,94V52.9h6.4l19.9,32h0.2 l-0.2-7.9v-24h5.3V94h-5.5l-20.9-33.5h-0.2l0.2,7.9V94L521.6,94"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M521.6,94h0.7V53.6h5.4l19.9,32h1.3l-0.2-8.6V53.6h3.9v39.7h-4.4l-20.9-33.5h-1.3l0.2,8.6v24.9h-4.6L521.6,94 l0.7,0L521.6,94l0,0.7h6V68.4l-0.2-7.9l-0.7,0v0.7h0.2v-0.7l-0.6,0.4l21.1,33.8h6.6V52.3h-6.6V77l0.2,7.9l0.7,0v-0.7h-0.2v0.7 l0.6-0.4l-20.1-32.3h-7.5v42.5h0.7L521.6,94 M736,210.5h12.8v-85.6H736L736,210.5z M850.9,155.7l-14.6,37.1h-0.4l-15.2-37.1H807 l22.8,51.9l-13,28.9h13.3l35.1-80.7L850.9,155.7z M778.6,200.7c-4.2,0-10-2.1-10-7.3c0-6.6,7.3-9.1,13.5-9.1 c5.6,0,8.2,1.2,11.7,2.9C792.8,195.1,785.9,200.7,778.6,200.7L778.6,200.7z M780.1,153.8c-9.2,0-18.8,4.1-22.8,13.1l11.3,4.7 c2.4-4.7,6.9-6.3,11.7-6.3c6.6,0,13.3,4,13.4,11v0.9c-2.3-1.3-7.3-3.3-13.3-3.3c-12.2,0-24.6,6.7-24.6,19.3 c0,11.5,10,18.8,21.2,18.8c8.6,0,13.3-3.9,16.3-8.4h0.4v6.6h12.3v-32.8C806.1,162.3,794.8,153.8,780.1,153.8L780.1,153.8z  M701.3,166.1h-18.1v-29.3h18.1c9.5,0,15,7.9,15,14.7C716.2,158.1,710.8,166.1,701.3,166.1z M700.9,124.8h-30.6v85.6h12.8V178h17.8 c14.1,0,28-10.3,28-26.6C729,135.1,715.1,124.8,700.9,124.8L700.9,124.8z M534.2,200.8c-8.8,0-16.2-7.4-16.2-17.5 c0-10.3,7.4-17.8,16.2-17.8c8.7,0,15.5,7.5,15.5,17.8C549.8,193.4,542.9,200.8,534.2,200.8L534.2,200.8z M548.9,160.5h-0.4 c-2.9-3.4-8.4-6.5-15.3-6.5c-14.5,0-27.9,12.8-27.9,29.2c0,16.3,13.3,29,27.9,29c6.9,0,12.4-3.1,15.3-6.6h0.4v4.2 c0,11.1-5.9,17.1-15.5,17.1c-7.8,0-12.7-5.6-14.7-10.4l-11.1,4.6c3.2,7.7,11.7,17.2,25.8,17.2c15,0,27.6-8.8,27.6-30.3v-52.3h-12.1 L548.9,160.5z M569.8,210.5h12.8v-85.6h-12.8V210.5z M601.4,182.2c-0.3-11.3,8.7-17,15.2-17c5.1,0,9.4,2.5,10.8,6.2L601.4,182.2z  M641.1,172.5c-2.4-6.5-9.8-18.5-24.9-18.5c-15,0-27.4,11.8-27.4,29.1c0,16.3,12.3,29.1,28.9,29.1c13.3,0,21-8.2,24.2-12.9 l-9.9-6.6c-3.3,4.9-7.8,8.1-14.3,8.1c-6.5,0-11.1-3-14.1-8.8l38.9-16.1L641.1,172.5z M331.3,162.9v12.4h29.5 c-0.9,7-3.2,12-6.7,15.6c-4.3,4.3-11,9-22.8,9c-18.2,0-32.4-14.7-32.4-32.9c0-18.2,14.2-32.9,32.4-32.9c9.8,0,17,3.9,22.3,8.8 l8.7-8.7c-7.4-7.1-17.2-12.5-31-12.5c-24.9,0-45.8,20.3-45.8,45.2c0,24.9,20.9,45.2,45.8,45.2c13.4,0,23.6-4.4,31.5-12.7 c8.2-8.2,10.7-19.6,10.7-28.9c0-2.9-0.2-5.5-0.7-7.7L331.3,162.9z M407,200.8c-8.8,0-16.4-7.3-16.4-17.7c0-10.5,7.6-17.7,16.4-17.7 c8.8,0,16.4,7.2,16.4,17.7C423.5,193.5,415.9,200.8,407,200.8z M407,154c-16.1,0-29.2,12.2-29.2,29.1c0,16.8,13.1,29.1,29.2,29.1 c16.1,0,29.2-12.4,29.2-29.1C436.2,166.2,423.1,154,407,154z M470.7,200.8c-8.8,0-16.4-7.3-16.4-17.7c0-10.5,7.6-17.7,16.4-17.7 c8.8,0,16.4,7.2,16.4,17.7C487.1,193.5,479.5,200.8,470.7,200.8L470.7,200.8z M470.7,154c-16.1,0-29.2,12.2-29.2,29.1 c0,16.8,13.1,29.1,29.2,29.1c16.1,0,29.2-12.4,29.2-29.1C499.9,166.2,486.8,154,470.7,154L470.7,154z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.7,57.1c-2.3,2.1-3.7,5.5-3.7,10.1v-1v151.5v-1c0,4.2,1.2,7.5,3.2,9.6l0.5,0.5v0c1.6,1.5,3.7,2.2,6,2.2 c2.3,0,4.9-0.7,7.7-2.3l99.2-56.5l34.1-19.4c4.3-2.5,6.8-5.6,7.2-8.9v0c-0.4-3.2-2.8-6.4-7.2-8.9l-34.1-19.4L90.4,57.2 c-2.8-1.6-5.4-2.3-7.7-2.3C80.4,54.9,78.3,55.7,76.7,57.1L76.7,57.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 639.7737,
    y1: 323.882,
    x2: 499.6468,
    y2: 593.371,
    gradientTransform: "matrix(0.2221 0 0 0.4265 -14.5391 -73.0798)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.006569999,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.7,226.8l-0.5-0.5c-2-2.1-3.2-5.4-3.2-9.6v1V66.3v1c0-4.6,1.4-8,3.7-10.1l84.7,84.9L76.7,226.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 578.9659,
    y1: 551.0111,
    x2: 93.9609,
    y2: 551.0111,
    gradientTransform: "matrix(0.3411 0 0 0.2777 38.6793 -11.0444)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M189.6,170.3L161.4,142l28.2-28.3l34.1,19.4c4.3,2.5,6.8,5.6,7.2,8.9v0c-0.4,3.2-2.8,6.4-7.2,8.9L189.6,170.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 615.3442,
    y1: 398.4352,
    x2: 173.2692,
    y2: 737.2832,
    gradientTransform: "matrix(0.3506 0 0 0.2702 -48.7257 53.495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M82.7,229.1c-2.4,0-4.4-0.8-6-2.2v0l84.7-84.8l28.2,28.3l-99.2,56.5C87.7,228.3,85.1,229.1,82.7,229.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.0486,
    y1: 316.0817,
    x2: 471.1476,
    y2: 467.3867,
    gradientTransform: "matrix(0.3506 0 0 0.2702 -48.6595 -33.3981)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M161.4,142L76.7,57.1c1.6-1.5,3.7-2.2,6-2.2c2.3,0,4.9,0.7,7.7,2.3l99.2,56.5L161.4,142"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.4421,
    y1: 975.8541,
    x2: 355.4421,
    y2: 975.8541,
    gradientTransform: "matrix(0.3506 0 0 0.2702 -48.6595 -33.3981)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M75.9,230.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 525.2743,
    y1: 425.085,
    x2: 449.4703,
    y2: 644.6689,
    gradientTransform: "matrix(0.181 0 0 0.5234 -2.4457 -149.5544)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#008DE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.006569999,
    style: {
      stopColor: "#008DE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00B8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00C4E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C7E0"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M76.2,227.3c-2-2.1-3.2-5.4-3.2-9.6v-1c0,4.2,1.2,7.5,3.2,9.6l0.5,0.5L76.2,227.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 481.5607,
    y1: 586.3282,
    x2: 31.5247,
    y2: 586.3282,
    gradientTransform: "matrix(0.3676 0 0 0.2577 59.1424 5.3549)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0C500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#E0A600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#E09100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E08900"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M190.3,170.9l-0.6-0.6l34.1-19.4c4.3-2.5,6.8-5.6,7.2-8.9c0,1.2-0.3,2.4-0.8,3.5c-1.1,2.3-3.2,4.5-6.4,6.3 L190.3,170.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 481.5637,
    y1: 585.6708,
    x2: 31.5217,
    y2: 585.6708,
    gradientTransform: "matrix(0.3676 0 0 0.2577 59.1442 -23.4117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE840"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFCE40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFBC40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB540"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M230.9,142c-0.4-3.2-2.8-6.4-7.2-8.9l-34.1-19.4l0.6-0.6h0l33.5,19C228.5,134.8,230.9,138.4,230.9,142"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.9633,
    y1: 698.3657,
    x2: 355.5843,
    y2: 907.8326,
    gradientTransform: "matrix(0.1807 0 0 0.5242 -2.3724 -310.3866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40B8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.006569999,
    style: {
      stopColor: "#40B9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#40CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#40DDFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#40E7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40EAFF"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M73,67.3v-1c0-0.4,0-0.7,0-1.1v0c0,0,0,0,0,0v0c0.2-3.7,1.3-6.5,3.1-8.4l0.5,0.5C74.4,59.2,73,62.7,73,67.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 433.316,
    y1: 809.4526,
    x2: 433.316,
    y2: 809.4526,
    gradientTransform: "matrix(0.1807 0 0 0.5242 -2.3724 -310.3866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40B8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.006569999,
    style: {
      stopColor: "#40B9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#40CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#40DDFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#40E7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40EAFF"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M75.9,113.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.bc3f17091505c22587debd173123580d.svg";
export { ForwardRef as ReactComponent };